<template>
  <div class="fc-header-toolbar fc-toolbar custom-toolbar">
    <div class="fc-toolbar-left">
      <div class="fc-button-group">
        <button type="button" class="fc-prev-button fc-button fc-button-primary" title="Previous" :disabled="disablePrev" @click="$emit('prev')">
          <i class="far fa-arrow-left"  aria-hidden="true"></i><span class="u-hidden-visually">Prevoius</span>
        </button>
        <button type="button" class="fc-next-button fc-button fc-button-primary" title="Next" @click="$emit('next')">
          <i class="far fa-arrow-right"  aria-hidden="true"></i><span class="u-hidden-visually">Next</span>
        </button>
      </div>
      <h2 class="fc-toolbar-title">{{ title }}</h2>
    </div>

    <div class="fc-toolbar-center fc-custom-legend">
     <span
     class="fc-custom-legend-wrap"
    v-for="type in eventTypes"
    :key="type"
  >
    <span
        class="fc-custom-legend-item "
        :class="`fc-custom-legend-item--${cleanForSlug(type)}`"
    ></span>
    {{ type }}
  </span>
    </div>

    <div class="fc-toolbar-right fc-custom-buttons">
      <a href="/whats-on/" class="c-btn c-btn--ghost">Event List</a>
      <span class="c-btn c-btn--primary">Calendar</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarToolbar',
  props: {
    title: String,
    eventTypes: {
        type: Array,
        default: () => []
    },
    disablePrev: {
        type: Boolean,
        default: false
    }
  },
  
  methods: {
    // Javascript version of sanitize_title()
    cleanForSlug(str)	{
        str = str.replace(/^\s+|\s+$/g, '');
        str = str.toLowerCase();

        str = str.replace(/[^a-z0-9 -]/g, '') 
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');

        return str;
    }
  }
}
</script>

